import { render } from "./MainBannerManageView.vue?vue&type=template&id=c3e64382&scoped=true"
import script from "./MainBannerManageView.vue?vue&type=script&lang=js"
export * from "./MainBannerManageView.vue?vue&type=script&lang=js"

import "./MainBannerManageView.vue?vue&type=style&index=0&id=c3e64382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e64382"]])

export default __exports__